module.exports = __webpack_public_path__ + "img/proList2_11.ddd04908.jpg";